
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{this.formType}} USER</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      
      <div class="p-6">
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Title</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="title"
						v-model="title" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in titles" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('title') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>First Name</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur"
						name="firstName"
						 class="w-full" v-model="firstName" />
						<span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Last Name</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur" 
						name="lastName"
						class="w-full" v-model="lastName" />
						<span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
					</div>
				</div>
				
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Mobile</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input class="w-full" 
						v-validate="'numeric'" 
						data-vv-validate-on="blur" 
						name="phone" 
						v-model="phone" />
						<span class="text-danger text-sm">{{ errors.first('phone') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Position</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						autocomplete
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="position"
						v-model="position" 
						class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in positions" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('position') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Level</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="positionLevel"
						v-model="positionLevel" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in positionLevels" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('positionLevel') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Hire Status</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="hireStatus"
						v-model="hireStatus" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in hireStatuses" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('hireStatus') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Job Function</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur"
						name="jobFunction"
						 class="w-full" v-model="jobFunction" />
						<span class="text-danger text-sm">{{ errors.first('jobFunction') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Region</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="region"
						v-model="region" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in regions" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('region') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>City Area</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select Region First"
						data-vv-validate-on="blur" 
						name="area"
						v-model="area" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in areas" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('area') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Branch</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select Aria First"
						v-model="branch" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in branches" />
						</vs-select>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>English Level</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						v-model="engLevel" 
						class="w-full">
							<vs-select-item :key="item" :value="item" :text="item" v-for="item in [1,2,3,4,5,6,7,8,9,10]" />
						</vs-select>
					</div>
				</div>

        <div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Role</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						v-model="role" class="w-full">
							<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in role_choices" />
						</vs-select>
					</div>
				</div>

        <div v-if="formType=='EDIT'" class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Email Verified</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						v-model="emailVerified" class="w-full">
							<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in yesno_choices" />
						</vs-select>
					</div>
				</div>
        <div v-if="formType=='CREATE'" class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Email</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
                                        v-validate="'required|email'"
                                        data-vv-validate-on="blur"
                                        name="email"
                                        type="email"
                                        placeholder="Email"
                                        v-model="email"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
					</div>
				</div>
        <div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Password</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        v-validate="'min:6'"
                                        name="password"
                                        placeholder="Password"
                                        v-model="password"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Confirm</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
                                        type="password"
                                        v-validate="'min:6|confirmed:password'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        v-model="confirmPassword"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('confirmPassword') }}</span>
					</div>
				</div>
        

        <!-- IMG -->
        <vs-upload v-show="false" text="Upload Image" class="img-upload" ref="fileUpload" />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" :disabled="!isValidFormChangePassword" @click="submitForm">Save</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import axios from 'axios'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { AUTH_PROVIDER, ROLE, API_BASE_URL, ROLE_CHOICES, YESNO_CHOICES, NAME_TITLE_TH } from '@/constants'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      userId: null,
      email: null,
			firstName: null,
			lastName: null,
			
			title: null,
			titles: [],

			phone: null,
			password: '',
			confirmPassword: '', // use '' insteads of null
			
			position: null,
			positions: [],

			positionLevel: null,
			positionLevels: [],

			hireStatus: null,
			hireStatuses: [],
			jobFunction: null,
			engLevel: null,

			region: null,
			regions: [],
			area: null,
			areas: [],
			branch: null,
			branches: [],
      
      provider: AUTH_PROVIDER.local,
      role: null,
      emailVerified: true,
      enabled: false,

      role_choices: ROLE_CHOICES,
      yesno_choices: YESNO_CHOICES,
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
      formType: null // CREATE, EDIT
    }
  },
  created() {
    this.initValues();
    
  },
  watch: {
		region(newVal, oldVal) {
			if(newVal != null) {
				const result = this.regions.find( it => it.text === newVal );
				this.areas = result.areas;
				this.area = null;
				this.branch = null;
			}
		},
		area(newVal, oldVal) {
			if(newVal != null) {
				const result = this.areas.find( it => it.text === newVal );
				this.branches = result.branches;
				this.branch = null;
			}
		},
		branch(newVal, oldVal) {
			
      	},
	},
  computed: {
    isValidFormChangePassword() {
      return !this.errors.any() && (this.password  && this.confirmPassword || !!this.password == !!this.confirmPassword);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.resetFormEditProfile();
        }
      }
    }
  },
  methods: {

    initValues() {
      let vm = this;
      
      this.resetFormEditProfile();

      axios.get("/excise/regions.json")
      .then(response =>{
        this.regions = response.data;
      })
      .catch(error =>{
        console.log(error);
      });

      axios.get(API_BASE_URL+"api/excise/constants/ExcisePosition")
      .then(response =>{
        this.positions = response.data;
      })
      .catch(error =>{
        console.log(error);
      });

      axios.get(API_BASE_URL+"api/excise/constants/ExcisePositionLevel")
      .then(response =>{
        this.positionLevels = response.data;
      })
      .catch(error =>{
        console.log(error);
      });

      axios.get(API_BASE_URL+"api/excise/constants/ExciseHireStatus")
      .then(response =>{
        this.hireStatuses = response.data;
      })
      .catch(error =>{
        console.log(error);
      });

    },
    submitFormEditProfile() {
      let vm = this;
			this.$validator.validate().then(valid => {
				if (!valid) {
					this.$vs.notify({
						title: this.$t('Alert'),
						text: 'Please input all required data.',
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'
					});
					return;
				}
			});

			let exciseUserInfo = {
				firstName: this.firstName,
				lastName: this.lastName,
				title: this.title,
				position: this.position,
				positionLevel: this.positionLevel,
				hireStatus: this.hireStatus,
				jobFunction: this.jobFunction,
				engLevel: this.engLevel,
				region: this.region,
				area: this.area,
				branch: this.branch
      }
      
      let showName = "";
      if(this.firstName) {
        showName += this.firstName + " ";
      }
      if(this.lastName) {
        showName +=  this.lastName;
      }
      if(showName == "") {
        showName = this.email;
      }

      let profile = {
        email: this.email,
        password: this.password,
        displayName: showName,
        phoneNumber: this.phone,
        emailVerified: this.emailVerified,
        exciseUserInfo: exciseUserInfo,
        userInfo: null
      }

      console.log(profile);
      if(this.formType == 'EDIT') {
        axios.put(API_BASE_URL + `api/users/${this.userId}`, profile)
        .then(response => {
          console.log(response.data);

          vm.$emit(`event:onUpdateUserProfileResponse`, response.data);
          this.isSidebarActiveLocal = false;

          this.$vs.notify({
            title: this.$t('Alert'),
            text: this.$t('Update user profile successfully'),
            color:'success',
            iconPack: 'feather',
            // position: 'top-center',
            icon:'icon-alert-circle',
            time: 6000
          });
          
        })
        .catch(error => {
          console.log(error);
          this.isSidebarActiveLocal = false;
          this.$vs.notify({
            title: this.$t('Alert'),
            text: 'Error updating an profile, please contact admin',
            color:'danger',
            iconPack: 'feather',
            // position: 'top-center',
            icon:'icon-alert-circle',
            time: 6000
          });
        });
      }
      
      if(this.formType == 'CREATE') {
        axios.post(API_BASE_URL + `api/users`, profile)
        .then(response => {
          console.log(response.data);

          vm.$emit(`event:onCreateUserProfileResponse`, response.data);
          this.isSidebarActiveLocal = false;

          this.$vs.notify({
            title: this.$t('Alert'),
            text: this.$t('Create user profile successfully'),
            color:'success',
            iconPack: 'feather',
            // position: 'top-center',
            icon:'icon-alert-circle',
            time: 6000
          });
          
        })
        .catch(error => {
          console.log(error);
          this.isSidebarActiveLocal = false;
          this.$vs.notify({
            title: this.$t('Alert'),
            text: 'Error creating an profile, please contact admin',
            color:'danger',
            iconPack: 'feather',
            // position: 'top-center',
            icon:'icon-alert-circle',
            time: 6000
          });
        });
      }
      
		},
		submitFormChangePassword() {
			if(this.formType != 'EDIT') {
				return;
			}

			let payload = {
				password: this.password,
				confirmPassword: this.confirmPassword,
			}
			axios.put(API_BASE_URL + `api/users/${this.userId}/changePassword`,payload)
			.then(response => {
				console.log(response);
				this.resetFormChangePassword();
				this.$vs.notify({
					title: this.$t('Alert'),
					text: this.$t('Update user password successfully'),
					color:'success',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			})
			.catch(error => {
				console.log(error);
				this.$vs.notify({
					title: this.$t('Alert'),
					text: error.response.data.message,
					color:'danger',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			});
    },
		resetFormEditProfile() {
			this.email = null;
			this.firstName = null;
			this.lastName = null;
			this.title = null;
			this.phone = null;
			this.password = '';
      this.confirmPassword = ''; // use '' insteads of null
      this.password = null;
			this.confirmPassword = null;

      this.provider = AUTH_PROVIDER.local;
      this.role = 'ROLE_EDITOR';
      this.emailVerified = true;
      this.enabled = true;

      this.titles = NAME_TITLE_TH;
    },
    // Invoke from parent component
    setValues(data, type) { // type = 'CREATE', 'EDIT'
      this.resetFormEditProfile();
      this.formType = type;
      
      if(type == 'CREATE') {
        return;
      }

      this.userId = data.id;
      this.email = data.email;
      this.firstName= data.exciseUserInfo.firstName;
      this.lastName= data.exciseUserInfo.lastName;
      this.title= data.exciseUserInfo.title;
      this.phone= data.phoneNumber;
      this.position= data.exciseUserInfo.position;
      this.positionLevel= data.exciseUserInfo.positionLevel;
      this.hireStatus= data.exciseUserInfo.hireStatus;
      this.jobFunction= data.exciseUserInfo.jobFunction;
      this.engLevel= data.exciseUserInfo.engLevel;
      this.region= data.exciseUserInfo.region;
      this.area= data.exciseUserInfo.area;
      this.branch= data.exciseUserInfo.branch;
      
      this.provider = data.provider;
      this.role = data.role;
      this.emailVerified = data.emailVerified;
      this.enabled = data.enabled;
    },
    submitForm() {
      console.log('Update user profile');
      this.submitFormEditProfile();

      if( (this.password  && this.confirmPassword && !!this.password == !!this.confirmPassword) ) {
        console.log('Update password');
        this.submitFormChangePassword();
      }
    }
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
